{
	"placeholder": "Sélectionner la période",
	"filterBy": "Filtrer par :",
	"applyPeriod": "Définir la période",
	"ariaLabels": {
		"selectDateRange": "Sélectionner une plage de dates",
		"dateRangeDialog": "Sélection de la plage de dates",
		"dateRangeSelection": "Calendrier de sélection de plage de dates",
		"clearSelection": "Effacer la sélection de dates"
	}
}
